import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Package } from '@vendasta/marketplace-packages';

@Injectable()
export class PipelineFilterPackageSelectionService {
  private readonly selectedPackages$$ = new ReplaySubject<Package[]>(1);
  readonly selectedPackages$ = this.selectedPackages$$.asObservable();

  setPackageSelection(pkgs: Package[]): void {
    this.selectedPackages$$.next(pkgs);
  }

  clearPackageSelection(): void {
    this.setPackageSelection([]);
  }
}
